import React from 'react'
import { SearchSection, UseSelectBoxFeild } from '../student/MyCourses'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Box, Button, Divider, Grid, Grid2, Typography } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import AddIcon from '@mui/icons-material/Add';
import { Icon } from "@iconify/react";
import PayoutTable from './PayoutTable'

const BillSumaryCard = ({ bgcolor, textcolor, iconimg, title }) => {
  return (
    <Box sx={{
      bgcolor: bgcolor,
      py: 5,
      borderRadius: "15px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 2
    }}>
      {iconimg}
      <Box>
        <Typography variant='h6' color={textcolor}>{title}</Typography>
        <Typography variant='h4' color={textcolor}>20,000</Typography>
      </Box>
    </Box>
  )
}

const Payout = () => {
  const BilSummaryData = [
    {
      bgcolor: "#E2FFDE",
      title: "Total Payouts",
      textcolor: "#0B7900",
      icon: <Icon icon="fluent:money-16-regular" color='#0B7900' fontSize={"40px"} />
    },
    {
      bgcolor: "#E7EDFF",
      title: "Total Withdrawn",
      textcolor: "#4169E1",
      icon: <Icon icon="mdi:credit-card-refund-outline" color='#4169E1' fontSize={"40px"} />
    },
    {
      bgcolor: "#FFE7E7",
      title: "Approval Pending",
      textcolor: "#870D0D",
      icon: <Icon icon="charm:circle-cross" color='#870D0D' fontSize={"40px"} />
    },
  ]
  return (
    <Box>
      {/* <SearchSection /> */}
      <CustomDivider orientation='horizontal' />
      <Grid2 container spacing={"30px"}>
        <Grid2 children size={{ xs: 12, lg: 8 }}>
          <NormalContainerWithHeader headerText={"Bill Summary"} RightContent={<Button variant="contained" startIcon={<AddIcon />}>Request for payout</Button>}>
            <Grid2 container spacing={3}>
              {
                BilSummaryData.map((item, index) => (
                  <Grid2 children size={4} key={index}>
                    <BillSumaryCard bgcolor={item.bgcolor} iconimg={item.icon} textcolor={item.textcolor} title={item.title} />
                  </Grid2>
                ))
              }
            </Grid2>
          </NormalContainerWithHeader>

        </Grid2>
        <Grid2 children size={{ xs: 12, lg: 4 }}>
          <NormalContainerWithHeader headerText={"Monthly Earnings"}>
            <Grid2 container spacing={3}>
              <Grid2 children size={7}>
                <UseSelectBoxFeild label="Month" />
              </Grid2>
              <Grid2 children size={5}>
                <UseSelectBoxFeild label="2025" />
              </Grid2>
              <Grid2 children size={7}>
                <Typography variant='h5'>Earnings</Typography>
              </Grid2>
              <Grid2 children size={5}>
                <Typography variant='h5'>₹ 1,00,000</Typography>
              </Grid2>
              <Grid2 container sx={{ borderBottom: "1px solid #E6ECFF" }} size={12} pb={3}>
                <Grid2 children size={7}>
                  <Typography variant='h5'>Refund</Typography>
                </Grid2>
                <Grid2 children size={5}>
                  <Typography variant='h5'> ₹ 1000</Typography>
                </Grid2>
              </Grid2>
              <Grid2 children size={7}>
                <Typography variant='h5' fontWeight={500}>Total Earning</Typography>
              </Grid2>
              <Grid2 children size={5}>
                <Typography variant='h5'> ₹ 99,000</Typography>
              </Grid2>
            </Grid2>
          </NormalContainerWithHeader>
        </Grid2>
      </Grid2>
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader headerText={"All Payouts"} RightContent={<Typography variant='h5'>₹ 20,00,000</Typography>}>
        <Grid2 container spacing={2}>
          <Grid2 size={8}></Grid2>
          <Grid2 size={4}></Grid2>
        </Grid2>
        <PayoutTable />
      </NormalContainerWithHeader>
    </Box>
  )
}

export default Payout